import { ImageLoading } from "@common/component";
import AppSideModal from "@common/component/AppSideModal";
import AppText from "@common/component/AppText";
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem } from "@common/component/Timeline";
import { withOpacity } from "@common/helper";
import { HOST, makeGetApiRequest } from "@common/index";
import SeparatedItems from "@component/SeparatedItems";
import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import React from "react";

export type ApiResponse = {
  success: boolean;
  outbound_history_data: Array<{
    created_at: string;
    status: string;
    lead_id: number;
    registration_number: string;
    updated_by_user: string;
  }>;
  message: string;
};

interface OutboundHistoryModalProps {
  open: boolean;
  refurbId: number;
  onClose?: () => void;
}

const OutboundHistoryModal: React.FC<OutboundHistoryModalProps> = ({ open, refurbId, onClose }) => {
  const { data = [], isLoading } = useQuery({
    queryKey: ["outboundHistory", { refurbId }],
    queryFn: async () => {
      const response = await makeGetApiRequest<ApiResponse>(
        `${HOST}/external/outbound/get-outbound-history`,
        {
          params: {
            outbound_refurb_car_id: refurbId,
            order_by: "created_at",
          },
        },
        "Keycloak-Authorization",
        "bearer",
        "refurb"
      );
      return response.data?.outbound_history_data;
    },
    enabled: !!refurbId,
  });

  return (
    <AppSideModal open={open} onClose={onClose} title="History">
      {isLoading || !data.length ? (
        <Box height="100%" width="100%" display="flex">
          <ImageLoading />
        </Box>
      ) : (
        <Timeline>
          {data.map((item, idx) => (
            <TimelineItem key={idx}>
              <TimelineDot />
              {idx < data.length - 1 && <TimelineConnector />}
              <TimelineContent>
                <Box display="flex" flexDirection="column" rowGap="4px">
                  <AppText fontFamily="medium">{item.status}</AppText>
                  <SeparatedItems separator={<AppText color="#D9D9D9"> • </AppText>}>
                    <AppText color={withOpacity("#000000", 0.6)}>
                      {item.updated_by_user?.trim() || "Unknown User"}
                    </AppText>
                    <AppText color={withOpacity("#141414", 0.5)} style={{ fontStyle: "italic" }}>
                      {moment(item.created_at).format("Do MMM 'YY, h:mm A")}
                    </AppText>
                  </SeparatedItems>
                </Box>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      )}
    </AppSideModal>
  );
};

export default OutboundHistoryModal;
